import { render, staticRenderFns } from "./kaidan.vue?vue&type=template&id=0683f6f3&scoped=true"
import script from "./kaidan.vue?vue&type=script&lang=js"
export * from "./kaidan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683f6f3",
  null
  
)

export default component.exports